<template>
  <el-dialog
    :close-on-click-modal="false"
    title="维保明细详情"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="1000px"
  >
    <section v-loading="getDetailLoading">
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />
      <!-- 配件信息 -->
      <qx-card-inline title="配件信息">
        <section class="detailOtherInfo">
          <el-table
            class="tableBox"
            :data="originData.serviceRepairPartsList"
            tooltip-effect="dark"
          >
            <!-- 常规列表项 -->
            <el-table-column
              v-for="(item, index, key) in tableTitle"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :min-width="item.minW"
              :width="item.w"
            />
          </el-table>
        </section>
      </qx-card-inline>
      <!-- 配件信息 end -->
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      merLoading: false, // 商户选项loading中
      originData: {},
      tableTitle: [
        {
          label: '类型',
          prop: 'partsName',
        },
        {
          label: '数量(个)',
          prop: 'partsNumber',
        },
        {
          label: '总金额',
          prop: 'totalPartsPriceStr',
        },
        {
          label: '备注',
          prop: 'partsRemark',
        },
      ],
      detailData: {
        base: {
          label: '基本信息',
          tableData: {
            title: [
              {
                prop: 'plateNumber',
                label: '车牌号码',
              },
              {
                prop: 'payAmt',
                label: '申请金额',
              },
              {
                prop: 'driver',
                label: '司机姓名',
              },
              {
                prop: 'mobilePhone',
                label: '司机手机',
              },
              {
                prop: 'orderId',
                label: '订单号码',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        maintenance: {
          label: '维保信息',
          tableData: {
            title: [
              {
                prop: 'repairmanTel',
                label: '维修电话',
              },
              {
                prop: 'payAmt',
                label: '维修费用',
              },
              {
                prop: 'isNeedBillName',
                label: '发票类型',
              },
              {
                prop: 'serviceContent',
                label: '维修内容',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.originData = item;
      this.detailData.base.tableData.data = this.originData = item;
      this.detailData.maintenance.tableData.data = this.originData = item;
      item.fileIds.forEach((fileItem, index) => {
        this.detailData.base.tableData.title.push({
          label: `上传附件${index + 1}`,
          prop: `file${index + 1}`,
          type: 'img',
        });
        item[`file${index + 1}`] = fileItem.fileUrl;
      });
      item.beforePicList.forEach((fileItem, index) => {
        this.detailData.base.tableData.title.push({
          label: `受损图片${index + 1}`,
          prop: `beforePic${index + 1}`,
          type: 'img',
        });
        item[`beforePic${index + 1}`] = fileItem.fileUrl;
      });
    },
  },
};
</script>

<style>
</style>
